var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import styled from 'styled-components';
import { Lightbox } from '..';
var galleryLayouts = [
    [
        [1, 3, 1, 3],
        [3, 5, 1, 3],
        [5, 9, 1, 6],
        [1, 5, 3, 6],
        [1, 5, 6, 9],
        [5, 9, 6, 9],
    ],
    [
        [1, 5, 1, 5],
        [5, 9, 1, 5],
        [1, 5, 5, 9],
        [5, 7, 5, 7],
        [7, 9, 5, 7],
        [5, 9, 7, 9],
    ],
    [
        [1, 3, 1, 3],
        [3, 5, 1, 3],
        [5, 9, 1, 7],
        [1, 5, 3, 9],
        [5, 7, 7, 9],
        [7, 9, 7, 9],
    ],
];
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100%;\n    width: 100%;\n    padding-left: 2.5%;\n"], ["\n    height: 100%;\n    width: 100%;\n    padding-left: 2.5%;\n"])));
var GalleryContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: repeat(8, 10%);\n    grid-template-rows: repeat(8, 10%);\n    grid-gap: 2.5%;\n    height: 100%;\n    width: 100%;\n"], ["\n    display: grid;\n    grid-template-columns: repeat(8, 10%);\n    grid-template-rows: repeat(8, 10%);\n    grid-gap: 2.5%;\n    height: 100%;\n    width: 100%;\n"])));
var GalleryElement = styled.figure(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    grid-column-start: ", ";\n    grid-column-end: ", ";\n    grid-row-start: ", ";\n    grid-row-end: ", ";\n    margin: 0;\n    cursor: ", ";\n    &:hover {\n        transform: ", ";\n    }\n"], ["\n    grid-column-start: ", ";\n    grid-column-end: ", ";\n    grid-row-start: ", ";\n    grid-row-end: ", ";\n    margin: 0;\n    cursor: ", ";\n    &:hover {\n        transform: ", ";\n    }\n"])), function (props) { return galleryLayouts[props.layout][props.imageNumber][0]; }, function (props) { return galleryLayouts[props.layout][props.imageNumber][1]; }, function (props) { return galleryLayouts[props.layout][props.imageNumber][2]; }, function (props) { return galleryLayouts[props.layout][props.imageNumber][3]; }, function (props) { return props.lightbox ? "pointer" : "default"; }, function (props) { return props.lightbox ? "scale(1.01)" : ""; });
var GalleryImage = styled.img(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n"], ["\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n"])));
var Gallery = function (props) {
    var children = props.children, lightbox = props.lightbox, layout = props.layout;
    var _a = React.useState(-1), selected = _a[0], setSelected = _a[1];
    var childrenAmount = React.Children.toArray(children).length;
    // console.log(((selected % childrenAmount) + childrenAmount) % childrenAmount);
    var next = function () { return setSelected(((selected + 1 % childrenAmount) + childrenAmount) % childrenAmount); };
    var previous = function () { return setSelected(((selected - 1 % childrenAmount) + childrenAmount) % childrenAmount); };
    return (React.createElement(Container, null,
        lightbox && React.createElement(Lightbox, { selected: selected, active: selected >= 0, onClose: function () { return setSelected(-1); }, next: next, previous: previous }, children),
        React.createElement(GalleryContainer, null, React.Children.map(children, function (child, idx) {
            if (React.isValidElement(child) && idx <= 5) {
                return (React.createElement(GalleryElement, { imageNumber: idx, onClick: function () { return setSelected(idx); }, layout: layout !== null && layout !== void 0 ? layout : 0, lightbox: lightbox },
                    React.createElement(GalleryImage, { src: child.props.src })));
            }
            return React.createElement(React.Fragment, null);
        }))));
};
export default Gallery;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Gallery.js.map